var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeactivateFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3575_775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.416016 0.416626L19.5827 19.5833M12.0835 12.0841C15.2002 12.12 19.5827 12.9166 19.5827 12.9166V11.0416C19.5827 11.0416 14.9993 8.74996 11.8743 7.91663V3.50913C11.8743 2.85079 11.6827 2.20496 11.2852 1.68079C10.9538 1.23653 10.5938 0.814254 10.2077 0.416626H9.79102C9.40452 0.813937 9.04458 1.23624 8.71352 1.68079C8.31518 2.20496 8.12435 2.85079 8.12435 3.50913V7.91663L7.96102 7.96163M11.5693 14.4866C11.493 15.4892 11.4557 16.4944 11.4577 17.5C11.4577 17.5 12.4993 18.125 13.3327 18.9583V19.375C13.3327 19.375 11.4577 19.1666 9.99935 19.1666C8.54102 19.1666 6.66602 19.375 6.66602 19.375V18.9583C7.49935 18.125 8.54102 17.5 8.54102 17.5C8.54102 13.9833 8.12435 12.0833 8.12435 12.0833C4.99935 12.0833 0.416016 12.9166 0.416016 12.9166V11.0416C0.416016 11.0416 3.10935 9.69496 5.77435 8.69163",
    stroke: "#4A4A4A",
    strokeWidth: 0.833333
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3575_775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateFlight);
export default __webpack_public_path__ + "static/media/deactivate-flight.d1ebff993c0b941e741494f6d8e34e97.svg";
export { ForwardRef as ReactComponent };